import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3 w-full" }
const _hoisted_2 = { class: "text-sm text-gray-lp-300 text-center" }
const _hoisted_3 = {
  "data-testid": "booking-failed-modal-reason",
  class: "text-xl font-bold text-gray-lp-300 text-center"
}
const _hoisted_4 = { class: "flex flex-col mt-3 pt-6 gap-3 border-t border-gray-lp-2000" }
const _hoisted_5 = { class: "flex flex-row justify-between items-center" }
const _hoisted_6 = { class: "text-sm text-gray-lp-300" }
const _hoisted_7 = { class: "text-sm text-gray-lp-800 font-semibold" }
const _hoisted_8 = { class: "flex flex-row justify-between items-center" }
const _hoisted_9 = { class: "text-sm text-gray-lp-300" }
const _hoisted_10 = { class: "text-sm text-gray-lp-300 font-semibold" }
const _hoisted_11 = { class: "w-full items-center mx-auto flex flex-row rounded-b-md text-xs gap-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_ModalV3 = _resolveComponent("ModalV3")!

  return (_openBlock(), _createBlock(_component_ModalV3, _mergeProps({
    modelValue: _ctx.modelValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue = $event))
  }, _ctx.messageEntities, { dataTestIdContainer: 'booking-failed-modal' }), {
    custom: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("bookingV3.modalFailed.reason.title")), 1),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.errorData.reason), 1),
        _withDirectives(_createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("bookingV3.modalFailed.balance")), 1),
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.formatPriceRP(_ctx.balance)), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("bookingV3.modalFailed.price")), 1),
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.formatPriceRP(_ctx.price)), 1)
          ])
        ], 512), [
          [_vShow, _ctx.isErrorBalance]
        ])
      ])
    ]),
    "custom-button": _withCtx(() => [
      _createVNode("div", _hoisted_11, [
        (_ctx.isErrorBalance)
          ? (_openBlock(), _createBlock(_component_lp_button, {
              key: 0,
              title: _ctx.$t('bookingV3.modalFailed.button.back'),
              textColor: "red-lp-100",
              color: "red-lp-100",
              outline: "",
              customButton: "w-full text-sm",
              class: "w-full",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
              fontWeight: "semibold",
              isWidthFull: ""
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        _createVNode(_component_lp_button, {
          "data-testid": "booking-failed-modal-action",
          title: _ctx.errorData.title,
          textColor: "red-lp-100",
          color: "red-lp-100",
          outline: "",
          customButton: "w-full text-sm",
          class: "w-full",
          onClick: _ctx.onClickButton,
          fontWeight: "semibold",
          isWidthFull: "",
          iconLeft: _ctx.error ? '' : 'refresh'
        }, null, 8, ["title", "onClick", "iconLeft"])
      ])
    ]),
    _: 1
  }, 16, ["modelValue"]))
}